import Vue from 'vue';

export default {
    syncAttributes(context, { id, data }) {
        const url = `v1/me/attributes/${id}/sync`;
        return Vue.$axios.$put(url, data);
    },

    storeAttribute(context, { id, data }) {
        const url = `v1/me/attributes/${id}/options`;
        return Vue.$axios.$post(url, data);
    },

    getAttributes(context, attributeId) {
        let url = 'v1/me/attributes';
        if (attributeId) {
            url += `/${attributeId}/options`;
        }

        return Vue.$axios.$get(url);
    },

    attachAttribute(context, { id, data }) {
        const url = `v1/me/attributes/${id}/attach`;
        return Vue.$axios.$put(url, data);
    },

    detachAttribute(context, { id, data }) {
        const url = `v1/me/attributes/${id}/detach`;
        return Vue.$axios.$put(url, data);
    },

    orderAttributes(context, { id, data }) {
        const url = `v1/me/attributes/${id}/order`;
        return Vue.$axios.$put(url, data);
    },

    syncDesiredOccupation(context, data) {
        const url = 'v1/me/desired-occupations';
        return Vue.$axios.$post(url, data);
    },

    attachDesiredOccupation(context, data) {
        const url = 'v1/me/desired-occupations';
        return Vue.$axios.$put(url, data);
    },

    detachDesiredOccupation(context, data) {
        const url = 'v1/me/desired-occupations';
        return Vue.$axios.$request({ method: 'delete', url, data });
    },

    attachWorkLocation(context, locationId) {
        const url = `v1/me/work-locations/${locationId}`;
        return Vue.$axios.$put(url);
    },
};
